
/**
 * Represents the configuration settings for a value chart, defining its type, associated model value,
 * and display characteristics.
 */
export class ValueChartConfig {
  /**
   * The unique identifier for this chart configuration.
   */
  id?: string | null;

  /**
   * The code that identifies the type of chart that should be displayed i.e. bar, line.
   */
  chartTypeCode?: string | null;

  /**
   * The model value identifier associated with this chart configuration.
   */
  modelValueId?: string | null;

  /**
   * Optional, the category identifier associated with this chart configuration.
   */
  categoryId?: string | null;

  /**
   * The name of this chart configuration.
   */
  name?: string | null;

  /**
   * The title of this chart.
   */
  title?: string | null;

  /**
   * The subtitle of this chart.
   */
  subTitle?: string | null;

  /**
   * Indicates whether this chart displays data across multiple years.
   */
  isMultiYear?: boolean | null;
}

